import { NavLink } from "react-router";
import ActionButton from "./ActionButton.tsx";

import { useSentryStore } from "../stores/sentryStore.ts";
import { Trans } from "@lingui/react/macro";

export default function Footer() {
  const { feedback } = useSentryStore();

  async function openFeedback() {
    const form = await feedback?.createForm();
    form?.appendToDom();
    form?.open();
  }

  if (
    window.location.href.includes("/chats") ||
    window.location.href.includes("/mystudio/messages")
  ) {
    return null;
  }

  return (
    <footer className="bg-soluud-background mt-auto pb-16 sm:pb-0">
      <div className="accent-line mx-auto w-full max-w-6xl" />
      <div className="text-soluud-text-secondary mx-auto flex max-w-screen flex-col items-center justify-between gap-3 px-6 py-6 text-sm sm:flex-row">
        <div className="text-center sm:text-left md:pl-10">
          © {new Date().getFullYear()} Soluud
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 md:justify-end">
          <NavLink
            to="/privacy"
            className="hover:text-soluud-text-primary transition-colors duration-150"
          >
            <Trans>Privacy Policy</Trans>
          </NavLink>
          <NavLink
            to="/terms"
            className="hover:text-soluud-text-primary transition-colors duration-150"
          >
            <Trans>Terms & Conditions</Trans>
          </NavLink>
          <NavLink
            to="/impressum"
            className="hover:text-soluud-text-primary transition-colors duration-150"
          >
            <Trans>Impressum</Trans>
          </NavLink>
          <ActionButton type={"button"} onClick={openFeedback}>
            <Trans>Report a Bug</Trans>
          </ActionButton>
        </nav>
      </div>
    </footer>
  );
}
